// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 错误等级枚举 枚举类
 * 校验产生的错误等级枚举
 */
export enum EnumErrorLevel {
  /** 信息 : 信息提示 */
  Info = 1,
  /** 警告 : 警告 */
  Warning = 2,
  /** 错误 : 错误 */
  Error = 4
}

/**
 * 错误等级枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumErrorLevelMD {
  private static items = [
    new EnumItemMD('Info', 1, '信息', '信息提示'),
    new EnumItemMD('Warning', 2, '警告', '警告'),
    new EnumItemMD('Error', 4, '错误', '错误')
  ];

  static getItem(enumItem: EnumErrorLevel) {
    return this.items.find(item => item.name === EnumErrorLevel[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
